import { computed, DestroyRef, inject } from '@angular/core';
import { menuItem, menuItems, MenuItemService } from '@softline/application';
import { TerminalService } from '../services/terminal.service';
import { Router } from '@angular/router';
import { askFn } from '@softline/ui-core';

export interface TerminalOptions {
  exit?: 'protected' | null | undefined;
}

export function terminal(options: TerminalOptions) {
  const destroyRef = inject(DestroyRef);
  const service = inject(TerminalService);
  const router = inject(Router);
  const ask = askFn();
  menuItem(() => ({
    type: 'execute',
    name: 'terminal',
    outlet: 'action',
    title: 'Terminal starten',
    icon: 'fa-regular fa-screencast',
    canExecute: true,
    execute: async () => {
      if(options.exit === 'protected') {
        const result = await ask({
          title: 'Terminal starten',
          question: 'Möchten Sie wirklich das Terminal starten? Dies kann nur durch ein Passwort verlassen werden.'
        })
        if(result !== 'YES')
          return;
      }
      const route = '/terminal' + router.url;
      await router.navigate([route]);}
  }))
  service.register({terminalExit: options.exit})
  destroyRef.onDestroy(() => service.unregister());
  return menuItems
}
